import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotGear = ({ spotColor = "#C9DBFE", color = "#13126C", ...props }: IconProps) => {
    return (
        <SVG viewBox="0 0 40 40" fill="none" {...props}>
            <path
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
                fill={spotColor}
            />
            <path
                d="M15.477 38h9.046a.624.624 0 0 0 .625-.623V28.88l7.391 4.25a.623.623 0 0 0 .854-.228l4.523-7.801a.62.62 0 0 0-.229-.851L30.297 20l7.39-4.25a.621.621 0 0 0 .23-.85l-4.524-7.8a.626.626 0 0 0-.854-.228l-7.39 4.248V2.623A.624.624 0 0 0 24.522 2h-9.046a.624.624 0 0 0-.625.623v8.497L7.46 6.87a.627.627 0 0 0-.854.228l-4.523 7.8a.621.621 0 0 0 .229.852L9.703 20l-7.39 4.249a.625.625 0 0 0-.23.85L6.608 32.9a.623.623 0 0 0 .854.228l7.39-4.249v8.498c0 .344.28.623.626.623Z"
                stroke={color}
                strokeWidth={2.2}
                strokeLinejoin="round"
            />
        </SVG>
    );
};

SpotGear.displayName = "SpotGear";
